export const initialValues = {
  amenity_images: null,
  name: "",
  description: "",
  terms_and_condition: "",
  is_online_booking_available: 0,
  is_active: 0,
  amenity_occasion_prices: [], // ← correct key
};
